import { FunctionComponent, useState } from "react";
import farmSo from "stores/farm";
import SelectorDialogBase from "../base/SelectorDialogBase";
import WrapControl, { ICON_VARIANT, WrapControlProps } from "../base/WrapControl";



interface Props extends WrapControlProps {
	/** lo scope selezionato */
	scope?: string,
	/** il group selezionato */
	group?: string,
	/** quando si seleziona una GROW-UNIT  */
	onChange: (group: string) => void,
}

const SelectorScopeGroup: FunctionComponent<Props> = ({
	scope,
	group,
	onChange,
	...props
}) => {

	// STORE

	// HOOKs
	const [isOpen, setIsOpen] = useState(false)

	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (group: string) => {
		setIsOpen(false)
		if (group) onChange?.(group.toLowerCase())
	}
	const handleClear = () => {
		onChange?.(null)
	}

	// RENDER
	const groups = farmSo.state.scopes?.[scope]?.map(s => s?.toUpperCase()) ?? []
	const placeholder = !!scope ? (
		groups.length == 0
			? `No groups available for ${scope.toUpperCase()}`
			: `Select a group for ${scope.toUpperCase()}`)
		: "Select a scope first"
	const isDisabled = !scope || groups.length == 0

	return (<>
		<WrapControl
			disabled={isDisabled}
			variantIcon={ICON_VARIANT.PAGE}
			placeholder={placeholder}
			textValue={group?.toUpperCase() ?? ""}
			onClick={handleClick}
			onClickClear={handleClear}
			{...props}
		/>
		<SelectorDialogBase
			width={"auto"}
			height={null}
			items={groups}
			idSelect={group}
			title="SELECT A SCOPE GROUP"
			isOpen={isOpen}
			onClose={handleClose}
		/>
	</>)
}

export default SelectorScopeGroup

